import { useState, useEffect, useCallback } from "react"
import { fetchMyDay } from "../api/tasksApi"

const EMPTY = { overdue: [], today: [], upcoming: [], completed: [], snoozed: [] }

export function useMyDay() {
  const [buckets, setBuckets] = useState(EMPTY)
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const data = await fetchMyDay()
      setBuckets({ ...EMPTY, ...data })
    } catch {
      setBuckets(EMPTY)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { load() }, [load])

  return { buckets, loading, refresh: load }
}
